/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Request to upload lab report files
 */
export type LabReportUploadRequest = {
    /**
     * List of file IDs to upload
     */
    fileIds: Array<string>;
    /**
     * Lab order provider type
     */
    provider?: LabReportUploadRequest.provider;
};

export namespace LabReportUploadRequest {

    /**
     * Lab order provider type
     */
    export enum provider {
        TRUEPILL = 'TRUEPILL',
        BIO_REFERENCE_LAB = 'BIO_REFERENCE_LAB',
        PATIENT = 'PATIENT',
        ZENDESK = 'ZENDESK',
        GETLABS = 'GETLABS',
        QUEST = 'QUEST',
        LABCORP = 'LABCORP',
        KWIK_TRIP_CENTER_FOR_HEALTH = 'KWIK_TRIP_CENTER_FOR_HEALTH',
        OSF_HEALTH_CARE = 'OSF_HEALTH_CARE',
        EVERLYWELL = 'EVERLYWELL',
        TASSO = 'TASSO',
    }


}

